var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:telegram-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5967 4.61748C20.8541 4.50913 21.1359 4.47177 21.4126 4.50927C21.6894 4.54676 21.951 4.65776 22.1703 4.83069C22.3896 5.00362 22.5586 5.23218 22.6596 5.49256C22.7606 5.75295 22.7899 6.03564 22.7446 6.31123L20.3821 20.6414C20.1529 22.0237 18.6363 22.8164 17.3686 22.1279C16.3082 21.5519 14.7332 20.6644 13.3165 19.7383C12.6082 19.2748 10.4384 17.7904 10.705 16.7341C10.9342 15.831 14.58 12.4373 16.6634 10.4196C17.4811 9.62685 17.1082 9.16956 16.1425 9.89873C13.7446 11.7091 9.89461 14.4623 8.62169 15.2373C7.49878 15.9206 6.91336 16.0373 6.21336 15.9206C4.93628 15.7081 3.7519 15.3789 2.78523 14.9779C1.47898 14.4362 1.54253 12.6404 2.78419 12.1175L20.5967 4.61748Z",
    fill: "url(#paint0_linear_775_14726)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_775_14726",
    x1: 12.2972,
    y1: 4.49512,
    x2: 12.2972,
    y2: 22.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E4FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverTelegram);
export default __webpack_public_path__ + "static/media/hover-Telegram.3d791ac0d724cfbe21c0bd9234fb8498.svg";
export { ForwardRef as ReactComponent };